module.exports = __webpack_public_path__ + "img/Altruvest Logo Flag.fbf60c52.svg";